import * as React from 'react';

import { CurrentUser } from '@40seas/frontend/libs/entities';

export function useUser(): CurrentUser {
    const user = React.useContext(UserContext);

    if (!user) {
        return {
            auth0Id: '',
            organizations: [],
            fullName: '',
            email: '',
            emailVerified: false,
        };
    }

    return user;
}

export const UserContext = React.createContext<CurrentUser | undefined>(undefined);
